import React, { useState, useEffect, useCallback } from 'react';
import { Text } from '@cuemath/web-comps';
import { usePostSupportTeam, invalidateSupportTeams } from 'actions/support-agent';
import { CACHE_KEYS, ERROR_AUTO_CLEAR_MS } from '../../constants';
import { FormField, FormLabel, FormTextInput } from './styled';
import {
  ModalOverlay,
  ModalCard,
  ModalHead,
  ModalBody,
  ModalFoot,
  BtnPrimary,
  BtnSecondary,
  IconBtn,
  ModalErrorMsg,
} from '../../styled-comps';
import Icon from '../icon';

const CreateTeamModal = ({ open, onClose }) => {
  const [name, setName] = useState('');
  const [submitError, setSubmitError] = useState(null);

  const { post: postTeam, isProcessing: creating } = usePostSupportTeam({
    onComplete: error => {
      if (error) {
        setSubmitError(typeof error === 'string' ? error : 'Failed to create team');
      } else {
        invalidateSupportTeams(CACHE_KEYS.SUPPORT_TEAMS);
        handleClose();
      }
    },
  });

  const handleClose = useCallback(() => {
    setName('');
    setSubmitError(null);
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (!submitError) return undefined;
    const timer = setTimeout(() => setSubmitError(null), ERROR_AUTO_CLEAR_MS);
    return () => clearTimeout(timer);
  }, [submitError]);

  const handleSubmit = useCallback(() => {
    const trimmed = name.trim();
    if (!trimmed) return;
    postTeam({ name: trimmed });
  }, [name, postTeam]);

  if (!open) return null;

  return (
    <ModalOverlay onClick={handleClose}>
      <ModalCard onClick={e => e.stopPropagation()}>
        <ModalHead>
          <Text variant="body1Medium">Create New Team</Text>
          <IconBtn onClick={handleClose}>
            <Icon name="close" size={16} />
          </IconBtn>
        </ModalHead>
        <ModalBody>
          {submitError && <ModalErrorMsg>{submitError}</ModalErrorMsg>}
          <FormField>
            <FormLabel>Team Name</FormLabel>
            <FormTextInput
              autoFocus
              type="text"
              value={name}
              placeholder="Enter team name..."
              onChange={e => setName(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Enter' && name.trim() && !creating) handleSubmit();
              }}
            />
          </FormField>
        </ModalBody>
        <ModalFoot>
          <BtnSecondary onClick={handleClose}>Cancel</BtnSecondary>
          <BtnPrimary onClick={handleSubmit} disabled={!name.trim() || creating}>
            {creating ? 'Creating...' : 'Create Team'}
          </BtnPrimary>
        </ModalFoot>
      </ModalCard>
    </ModalOverlay>
  );
};

export default CreateTeamModal;
